export enum AccountStatus {
  unverified = 1,
  verified,
  blocked, // May be usable in future
}
